<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">
        <router-link
          :to="{ name: 'document.view', params: { id: document.id } }"
        >
          <FileIcon />
          <text-highlight :queries="[q]"
            >&nbsp;{{ document_version.name }}
          </text-highlight>
        </router-link>
      </h5>

      <p class="card-text">
        <text-highlight :queries="[q]"
          >{{ document_version.description }}
        </text-highlight>
      </p>
    </div>
  </div>
</template>
<script>
import TextHighlight from "vue-text-highlight";
import FileIcon from "vue-material-design-icons/File";

export default {
  name: "LibraryDocument",
  components: { TextHighlight, FileIcon },
  props: {
    q: {},
    document: {},
  },
  computed: {
    document_version() {
      const doc = this.document;
      if (doc.current_version) {
        return doc.current_version;
      } else {
        if (doc.current_draft) {
          return doc.current_draft;
        }
      }

      return {
        name: "Unknown document",
        description: "",
      };
    },
  },
};
</script>
